import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form__duo-fields" }

import {computed, onMounted, ref} from "vue"
import {useI18n} from "vue3-i18n"
import {OrganizationType} from "@/types"
import {IFullOrganization} from "@/types/entities/organization";
import FormReadonlyField from "@/components/forms/FormReadonlyField.vue"
import Card from "@/components/layout/Card.vue"
import FormRow from "@/components/forms/FormRow.vue"
import {useOrganizationService} from "@/inversify.config";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'SyndicateCoownerOrganizationView',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props

const {t, getLocale} = useI18n()
const organizationService = useOrganizationService()

const organization = ref<IFullOrganization>()
const organizationIsLoading = ref(false)

onMounted(async () => {
  await loadOrganization()
})

let organizationType = computed(() => {
  if (!organization.value)
    return
  let type = organization.value.type.makeFirstLetterLowercase()
  return t(`organization.types.${type}`)
})

async function loadOrganization() {
  organizationIsLoading.value = true

  let fullOrganization = await organizationService.getMyOrganization(getLocale())
  if (fullOrganization) {
    organization.value = fullOrganization
  }
  organizationIsLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (organization.value)
    ? (_openBlock(), _createBlock(Card, {
        key: 0,
        title: organization.value.name
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "form",
            enctype: "multipart/form-data",
            novalidate: "",
            onSubmit: _withModifiers(() => {}, ["prevent"])
          }, [
            _createVNode(FormRow, { withThreeColumns: true }, {
              default: _withCtx(() => [
                _createVNode(FormReadonlyField, {
                  modelValue: _unref(organizationType),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(organizationType) ? (organizationType).value = $event : organizationType = $event)),
                  label: _unref(t)('organization.type'),
                  name: "type"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.chapter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((organization.value.chapter) = $event)),
                  label: _unref(t)('organization.chapter'),
                  name: "chapter"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.enterpriseNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((organization.value.enterpriseNumber) = $event)),
                  label: _unref(t)('organization.enterpriseNumber'),
                  name: "enterpriseNumber"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(FormRow, { withThreeColumns: true }, {
              default: _withCtx(() => [
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.apartment,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((organization.value.apartment) = $event)),
                  label: _unref(t)('global.apartment'),
                  name: "apartment"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.street,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((organization.value.street) = $event)),
                  label: _unref(t)('global.street'),
                  name: "street"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.city,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((organization.value.city) = $event)),
                  label: _unref(t)('global.city'),
                  name: "city"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(FormRow, { withThreeColumns: true }, {
              default: _withCtx(() => [
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.zipCode,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((organization.value.zipCode) = $event)),
                  label: _unref(t)('global.zipCode'),
                  name: "zipCode"
                }, null, 8, ["modelValue", "label"]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(FormReadonlyField, {
                    modelValue: organization.value.phoneNumber,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((organization.value.phoneNumber) = $event)),
                    label: _unref(t)('global.phoneNumber'),
                    name: "phoneNumber"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(FormReadonlyField, {
                    modelValue: organization.value.phoneExtension,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((organization.value.phoneExtension) = $event)),
                    label: _unref(t)('global.phoneExtension'),
                    name: "phoneExtension"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((organization.value.email) = $event)),
                  label: _unref(t)('global.email'),
                  name: "email"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(FormRow, { withThreeColumns: true }, {
              default: _withCtx(() => [
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.subscription.startAt,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((organization.value.subscription.startAt) = $event)),
                  label: _unref(t)('organization.subscriptionStartAt'),
                  name: "subscriptionStartAt"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.subscription.endAt,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((organization.value.subscription.endAt) = $event)),
                  label: _unref(t)('organization.subscriptionEndAt'),
                  name: "subscriptionEndAt"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(FormReadonlyField, {
                  modelValue: organization.value.memberNumber,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((organization.value.memberNumber) = $event)),
                  label: _unref(t)('organization.memberNumber'),
                  name: "memberNumber"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(FormRow, { withThreeColumns: true }, {
              default: _withCtx(() => [
                (organization.value.type !== _unref(OrganizationType).Corporate)
                  ? (_openBlock(), _createBlock(FormReadonlyField, {
                      key: 0,
                      modelValue: organization.value.numberOfUnits,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((organization.value.numberOfUnits) = $event)),
                      label: _unref(t)('organization.numberOfUnits'),
                      name: "numberOfUnits"
                    }, null, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 40, _hoisted_1)
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})